module.exports = ({
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
  callbackEndpoint: process.env.REACT_APP_CALLBACK,
});



// WEBPACK FOOTER //
// ./src/utils/env.js